export type EnvxType =
  | "string"
  | "number"
  | "boolean"
  | "enum"
  | "email"
  | "url";

export interface EnvxVarSchema {
  type: EnvxType;
  required?: boolean;
  default?: string | number | boolean;
  values?: Array<string>;
  deprecated?: boolean;
  description?: string;
}

export type EnvxSchema = Record<string, EnvxVarSchema>;
export type EnvxVarKey = keyof EnvxVarSchema;

export type EnvxResult = Record<string, string | number | boolean>;

export class EnvxError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "EnvxError";
  }
}

// OTHERS
export type ParsedLine = { key: string; value: string };